/**
 * Detects browser and adds class to the body
 *
 *
 *
 */

function browserDetect (){
    let isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
    let isFirefox = typeof InstallTrigger !== 'undefined';
    let isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0 || !isChrome && !isOpera && window.webkitAudioContext !== undefined;
    let isIE = /*@cc_on!@*/false || !!document.documentMode;
    let isEdge = !isIE && !!window.StyleMedia;
    let isChrome = !!window.chrome && !!window.chrome.webstore;
    let body = document.querySelector('body');

    if (isOpera) {
        body.classList.add('is-opera')
    }
    if (isFirefox) {
        body.classList.add('is-firefox')
    }
    if (isIE) {
        body.classList.add('is-ie')
    }
    if (isEdge) {
        body.classList.add('is-edge')
    }
    if (isChrome) {
        body.classList.add('is-chrome')
    }
    if (isSafari) {
        body.classList.add('is-safari')
    }

};

module.exports = browserDetect;